import React, { Component } from 'react';

class Adstudio extends Component {
    render() {
        return (
            <div>
                <div className="made_by">PROJEKT JE NAPRAVLJEN U PRODUKCIJI <span className="native_studio"></span> HANZA MEDIJE I PLIVE, U SKLADU S NAJVIŠIM PROFESIONALNIM STANDARDIMA JUTARNJEG</div>
            </div>

        );
    }
}

export default Adstudio;


/** WEBPACK FOOTER **
 ** ./src/components/Adstudio.js
 **/